import { addDays } from 'date-fns';
import { Box, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { CalendarPicker } from '~/components/shared/forms';
import { TipBanner } from '~/components/shared/TipBanner';
import { SectionCard } from '~/components/ShiftRequestRedesign/common';
import { SelectedDatesList } from './SelectedDatesList';

interface IDatesCardProps {
  selectedDates: Date[];
  onCalendarSelect: (dates: Date[] | undefined) => void;
  onRemoveDate: (date: Date) => void;
  /** Applies error highlight to the calendar when true */
  hasError?: boolean;
  /** Controls visibility of the multi-day tip banner */
  tipVisible?: boolean;
}

export const DatesCard = ({
  selectedDates,
  onCalendarSelect,
  onRemoveDate,
  hasError,
  tipVisible = false,
}: IDatesCardProps) => {
  const today = new Date();

  return (
    <SectionCard title="Dates" testId="dates-card">
      <Typography as="span" size="body_large" color={colors.neutral[500]} style={{ fontWeight: 400 }}>
        Shifts can be posted up to 99 days in advance. Use the calendars to select your dates.
      </Typography>

      <Box style={{ marginTop: 12, marginBottom: tipVisible ? 16 : 0 }}>
        <TipBanner
          visible={tipVisible}
          description="You can post for more than one day! Save time by creating multiple shifts at once."
        />
      </Box>

      <Column align="center" style={{ marginTop: 14 }}>
        <CalendarPicker
          data-testid="dates-calendar"
          data-cy="dates-calendar"
          mode="multiple"
          numberOfMonths={2}
          selected={selectedDates}
          onSelect={onCalendarSelect}
          startMonth={today}
          disabled={[
            {
              before: today,
              after: addDays(today, 99),
            },
          ]}
          hasError={hasError}
        />
      </Column>

      <Box style={{ marginTop: 20 }}>
        <SelectedDatesList dates={selectedDates} onRemoveDate={onRemoveDate} />
      </Box>
    </SectionCard>
  );
};
